import { useContext } from 'react';

import { PracticeReseveContext } from '../../PracticeReseveContext';

import { PRACTICE_RESERVE_MODE } from '../../../../../models/practice/reserve/mode/PracticeReserveMode';

// アクセス集中
function PracticeReserveAccessAlert() {

  const { reserveMode } = useContext(PracticeReseveContext);

  // 日時から選ぶ：講師を選んでいないので、講師向けの案内は出さない
  if(reserveMode === PRACTICE_RESERVE_MODE.DATETIME) {
    return (
      <div className="alert alert-danger">
        <small>
          現在予約できる枠がありません。
        </small>
      </div>
    );
  }

  return (
    <div className="alert alert-danger">
      <small>
        大変申し訳ございません。<br />
        現在、こちらの講師のレッスン枠は未開放となっております。<br />
        <br />
        こちらの講師でのレッスンをご希望の場合は、<br />
        予約画面にて <span style={{fontWeight: 'bold'}}>「講師を選ぶ」→「希望講師がいない場合」</span><br />
        をご選択のうえ、リクエストをお送りください。<br />
        いただいたリクエスト内容を確認のうえ、可能な範囲で調整させていただきます。<br />
        <br />
        ご不便をおかけし恐れ入りますが、何卒よろしくお願いいたします。
      </small>
    </div>
  );
}
  
export default PracticeReserveAccessAlert;